import propType from 'prop-types';
import React from 'react';
import Card from '../BaseCard';

const VerticalArticleCard = ({
  type = 'vertical',
  title,
  categories,
  uri,
  featuredImage
}) => {
  return (
    <Card type={type} uri={uri} imageSrc={featuredImage} title={title}>
      <Card.Content key="content">
        <Card.Title>{title}</Card.Title>
      </Card.Content>
      <Card.Extra key="extra">
        <Card.Topic topic={categories} />
      </Card.Extra>
    </Card>
  );
};

VerticalArticleCard.defaultProps = {};

VerticalArticleCard.propTypes = {
  uri: propType.string.isRequired,
  title: propType.string.isRequired,
  featuredImage: propType.shape({}).isRequired,
  type: propType.string.isRequired,
  categories: propType.shape({}).isRequired
};

export default VerticalArticleCard;
